import React, { useState, useCallback } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";
import { useLang } from "@/i18n/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const inputCls = "rounded-none border-[#1A1F24]/20 h-12";
const initial = { name: "", email: "", phone: "", subject: "", message: "" };

const ContactForm = () => {
  const { t, lang } = useLang();
  const [form, setForm] = useState(initial);
  const [sending, setSending] = useState(false);

  const set = useCallback((k, v) => setForm((f) => ({ ...f, [k]: v })), []);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success(t.contact.sent);
      setForm(initial);
    } catch (err) {
      toast.error(lang === "es" ? "No se pudo enviar" : "Could not send");
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      data-testid="contact-form"
      onSubmit={submit}
      className="bg-white border border-[#EAE6DF] p-8 sm:p-10"
    >
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <Input
          data-testid="contact-name"
          value={form.name}
          onChange={(e) => set("name", e.target.value)}
          placeholder={t.contact.name}
          className={inputCls}
          required
        />
        <Input
          data-testid="contact-email"
          type="email"
          value={form.email}
          onChange={(e) => set("email", e.target.value)}
          placeholder={t.contact.email}
          className={inputCls}
          required
        />
        <Input
          data-testid="contact-phone-input"
          value={form.phone}
          onChange={(e) => set("phone", e.target.value)}
          placeholder={t.contact.phone}
          className={inputCls}
        />
        <Input
          data-testid="contact-subject"
          value={form.subject}
          onChange={(e) => set("subject", e.target.value)}
          placeholder={t.contact.subject}
          className={inputCls}
          required
        />
        <Textarea
          data-testid="contact-message"
          value={form.message}
          onChange={(e) => set("message", e.target.value)}
          placeholder={t.contact.message}
          className="rounded-none border-[#1A1F24]/20 min-h-[140px] sm:col-span-2"
          required
        />
      </div>
      <button
        data-testid="contact-submit"
        type="submit"
        disabled={sending}
        className="mt-6 w-full bg-[#1A1F24] hover:bg-[#2E4F4F] text-white py-4 text-xs uppercase tracking-[0.25em] disabled:opacity-60 transition-colors"
      >
        {sending ? t.contact.sending : t.contact.send}
      </button>
    </form>
  );
};

export default ContactForm;
